// ── Social system (matchmaking + challenges removed in v1 purge, V-3) ──
//
// `MatchmakingQueueType`, `MatchmakingStatus`, and `MATCHMAKING_API` were
// removed as part of V-3 (2026-04-24) alongside the ExpeditionRoom / matchmaking
// service purge in V-2. The v2 softening world has no queue — dungeon entry
// is a direct in-world zone switch. See `docs/v1-purge-plan.md` §3.
/** Default social config values */
export const SOCIAL_DEFAULTS = {
    maxFriends: 50,
    maxPartySize: 4,
    maxChatMessageLength: 500,
    chatHistoryLimit: 50,
    friendRequestCooldownMs: 5000,
};
// ── Social message types ──
export const MSG_FRIEND_REQUEST = 'friend_request';
export const MSG_FRIEND_ACCEPTED = 'friend_accepted';
export const MSG_FRIEND_DECLINED = 'friend_declined';
export const MSG_FRIEND_REMOVED = 'friend_removed';
export const MSG_FRIEND_STATUS = 'friend_status';
export const MSG_FRIENDS_LIST = 'friends_list';
export const MSG_PARTY_CREATED = 'party_created';
export const MSG_PARTY_INVITE = 'party_invite';
export const MSG_PARTY_JOINED = 'party_joined';
export const MSG_PARTY_LEFT = 'party_left';
export const MSG_PARTY_DISBANDED = 'party_disbanded';
export const MSG_PARTY_LEADER_CHANGED = 'party_leader_changed';
export const MSG_PARTY_SYNC = 'party_sync';
export const MSG_CHAT_MESSAGE = 'chat_message';
export const MSG_CHAT_HISTORY = 'chat_history';
// ── Hearth whisper chat (Round 14 Phase E) ──
// Proximity-bound ephemeral text at hearths (~10 tiles). No persistence.
export const MSG_HEARTH_WHISPER_SEND = 'hearth_whisper_send';
export const MSG_HEARTH_WHISPER_BROADCAST = 'hearth_whisper_broadcast';
/** Max characters per hearth whisper message. */
export const HEARTH_WHISPER_MAX_LENGTH = 200;
/** Proximity radius for hearth whisper visibility (px). ~10 tiles. */
export const HEARTH_WHISPER_RANGE_PX = 10 * 32;
/** Max whispers per player per minute (grief protection Phase F). */
export const HEARTH_WHISPER_RATE_LIMIT = 6;
/** Social API endpoint paths (relative to API_PORT) */
export const SOCIAL_API = {
    FRIENDS: '/social/friends',
    FRIEND_REQUESTS: '/social/friends/requests',
    FRIEND_REQUEST_SEND: '/social/friends/request',
    FRIEND_ACCEPT: '/social/friends/accept',
    FRIEND_DECLINE: '/social/friends/decline',
    FRIEND_REMOVE: '/social/friends/remove',
    PARTY_CREATE: '/social/party',
    PARTY_JOIN: '/social/party/join',
    PARTY_LEAVE: '/social/party/leave',
    PARTY_INVITE: '/social/party/invite',
    PARTY_GET: '/social/party',
    CHAT_HISTORY: '/social/chat',
};
/** Social protocol version */
export const SOCIAL_PROTOCOL_VERSION = 1;
// ── Challenge system removed in v1 purge, V-3 (2026-04-24) ──
//
// `ChallengeMetric`, `ChallengePeriodType`, `ChallengeRewardType`,
// `ChallengeDefinition`, `ActiveChallenge`, `ChallengeListResponse`,
// `CHALLENGE_API`, `CHALLENGE_DAILY_COUNT`, `CHALLENGE_WEEKLY_COUNT` were
// removed alongside the deletion of `ChallengeService` in V-2. Daily /
// weekly objectives are out of the v2 softening scope. See
// `docs/v1-purge-plan.md` §3.
//
// Leaderboards (`LEADERBOARD_API`) are a real v2 feature and remain in
// `types/leaderboard.ts`.
//# sourceMappingURL=social.js.map